export function decodeHtml(html: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

/**
 *
 * @param date date string
 *
 * 'created_at' dates coming back from the Yotpo API are in the format '2019-06-12T17:26:53.000Z'.
 * This function would transform this date string to 06/12/19.
 */
export const formatDate = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${month}/${day.substr(0, 2)}/${year.substr(2)}`;
};

/**
 *
 * @param text text to truncate
 * @param limit character count where truncation starts
 */
export const truncate = (text: string, limit: number) =>
  text.length > limit ? `${text.substr(0, limit - 1)}...` : text;
